<template lang='pug'>
  .monitoring-budget-confirm
    fpui-modal-header(
      :title="$t('fpui.monitoring.editor.modal_confirm.budget', [$t(label)])",
      :actions='actions',
      @close='$emit("close")',
      @check='save()'
    )
    fpui-modal-body
      h4 {{ $t('fpui.monitoring.editor.modal_confirm.budget.text') }}
      h4 {{ $t('fpui.monitoring.editor.modal_confirm.budget.amount', [amount, $t(label)]) }}
</template>

<script>

export default {
  props: {
    label: String,
    asked: Object,
    before: Object,
    save: Function
  },
  computed: {
    actions () { return [{name: 'check', class: 'fpui fpui-check'}] },
    amount () { return (this.asked.fpu * this.asked.instances) - (this.before.fpu * this.before.instances) }
  }
}
</script>
